/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import Icons from '../../icons/icons';
import type { MouseEvent } from 'react';

type TextWithCopyProps = {
  text: string;
  isCopied: boolean;
  handleCopy: (e: MouseEvent<HTMLButtonElement>) => Promise<void>;
  truncate?: boolean;
  label?: string;
};

const truncateText = (value: string) => {
  if (value.length <= 10) return value; // small strings unchanged
  const start = value.slice(0, 5);
  const end = value.slice(-5);
  return `${start}...${end}`;
};

const TextWithCopy = ({
  text,
  isCopied,
  handleCopy,
  truncate = false,
  label,
}: TextWithCopyProps) => {
  const displayText = truncate ? truncateText(text) : text;

  return (
    <span className="group relative inline-flex items-center">
      {label && <span className='capitalize text-body text-body-subtle font-normal'>{`${label}: `}</span>}
      <span className="rounded bg-[#FFFFFF14] px-[3px] text-body font-normal text-body-subtle hover:text-[#fff] ml-1">
        {displayText}
      </span>

      {/* Copy button */}
      <button
        aria-label="Copy value"
        className={`absolute right-0 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded bg-[#08242F] transition-opacity ${
          isCopied
            ? 'pointer-events-auto opacity-100'
            : 'pointer-events-none opacity-0 group-hover:pointer-events-auto group-hover:opacity-100'
        }`}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          handleCopy(e);
        }}
      >
        {isCopied ? Icons.CopyGreenCheckIcon() : Icons.CopyIcon()}
      </button>
    </span>
  );
};

export default TextWithCopy;
